import React from 'react';
import Skeleton from '../common/Skeleton';
import './ChannelDetailSkeleton.css';

const ChannelDetailSkeleton = () => {
    return (
        <div className="channel-detail-skeleton">
            {/* Header Skeleton */}
            <div className="channel-detail-skeleton-header">
                <Skeleton className="channel-detail-skeleton-cover" />
                <div className="channel-detail-skeleton-info-row">
                    <Skeleton
                        className="channel-detail-skeleton-avatar"
                        width={112}
                        height={112}
                    />
                    <div className="channel-detail-skeleton-meta">
                        <Skeleton width="40%" height={32} borderRadius="8px" />
                        <Skeleton width="60%" height={16} borderRadius="4px" />
                        <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                            <Skeleton width={100} height={36} borderRadius="10px" />
                            <Skeleton width={100} height={36} borderRadius="10px" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="channel-detail-skeleton-content">
                {/* Main Feed Skeleton */}
                <div className="channel-detail-skeleton-main">
                    {/* Create Post Input Skeleton */}
                    <div className="channel-detail-skeleton-create-post">
                        <Skeleton width={40} height={40} borderRadius="50%" />
                        <Skeleton width="100%" height={48} borderRadius="12px" />
                    </div>

                    {[1, 2, 3].map((i) => (
                        <div key={i} className="channel-detail-skeleton-post">
                            <div className="channel-detail-skeleton-post-header">
                                <Skeleton width={48} height={48} borderRadius="50%" />
                                <div style={{ flex: 1 }}>
                                    <Skeleton width={120} height={16} style={{ marginBottom: '6px' }} />
                                    <Skeleton width={80} height={12} />
                                </div>
                            </div>
                            <Skeleton width="90%" height={16} />
                            <Skeleton width="70%" height={16} />
                            <Skeleton width="100%" height={200} borderRadius="12px" style={{ marginTop: '12px' }} />
                        </div>
                    ))}
                </div>

                {/* Sidebar Skeleton */}
                <aside className="channel-detail-skeleton-sidebar">
                    {/* Rules Card */}
                    <div className="channel-detail-skeleton-card">
                        <Skeleton width={150} height={24} style={{ marginBottom: '16px' }} />
                        <Skeleton width="100%" height={16} />
                        <Skeleton width="100%" height={16} />
                        <Skeleton width="80%" height={16} />
                    </div>

                    {/* Pinboard Card */}
                    <div className="channel-detail-skeleton-card">
                        <Skeleton width={120} height={24} style={{ marginBottom: '16px' }} />
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                            <Skeleton width={40} height={40} borderRadius="8px" />
                            <div style={{ flex: 1 }}>
                                <Skeleton width="100%" height={14} style={{ marginBottom: '4px' }} />
                                <Skeleton width="60%" height={12} />
                            </div>
                        </div>
                    </div>

                    {/* Events Card */}
                    <div className="channel-detail-skeleton-card">
                        <Skeleton width={140} height={24} style={{ marginBottom: '16px' }} />
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <Skeleton width={50} height={50} borderRadius="10px" />
                            <div style={{ flex: 1 }}>
                                <Skeleton width="80%" height={14} style={{ marginBottom: '6px' }} />
                                <Skeleton width="40%" height={12} />
                            </div>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default ChannelDetailSkeleton;
